<template>
    <div>        
        <v-combobox
            keep_the_default_which_is_true-return-object="false"
            :rules="rules"
            :menu-props="{ maxHeight: maxHeight, bottom: true, offsetY: true }"
            :placeholder="placeholder"
            multiple
            :chips="chips"
            :item-text="itemText"
            :item-value="itemValue"
            v-model="dvalue"
            :items="items"
            dense
            outlined 
            hide-details
            clearable
            not-for-now-value-comparator="myValueComparator"
            :disabled="compDisabled">
            >
            <template v-slot:selection="{ item, index }">
                <StatusChip auto-width :status="item.status" :substatus="item.substatus" :type="item.type">{{ itemRep(item) }}</StatusChip>
           </template>

            </v-combobox>
    </div>
</template>
    
<script setup>
        import StatusChip from "@controls/widgets/StatusChip.vue";

        // import ActionComboMulti from '@controls/combo/ActionComboMulti'
        // const items = [{id: "A", name: "Goedgekeurd"}, {id: "R", name: "Afgekeurd"}, {id: "N", name: "Nieuw"}]
        // <ActionComboMulti :model="model" v-model="dvalue" :items="items"></ActionComboMulti>
    
        const props = defineProps({
            disabled: {
                type: [Boolean]
            },
            rules: {
                type: [Array]
            },
            skeleton: {
                type: [Boolean]
            },
            chips: {
                type: [Boolean],
                default: true
            },
            value: {
                type: [Array]
            },
            placeholder: {
                type: [String],
                default: 'Maak uw keuze'
            },
            model: {
                type: [Object]
            },
            items: {
                type: [Array]
            },
            maxHeight: {
                type: [Number, String],             
                default: "400"
            },
            itemText: {
                type: [String],
                default: 'name'
            },
            itemShortText: {
                type: [String],
                default: 'name'
            },
            itemValue: {
                type: [String],
                default: 'id'
            },                        
        })
        
        import {computed} from 'vue'
    

        const emit = defineEmits(['input'])
        
        // We want the combo to work with objects. Otherwise the visual selection does not work. 
        // However we want the (selected) inputs and outputs to be keys. 
        // Therefore map the input from keys to objects, and map the output from objects to keys. 
        const dvalue = computed({
            get() {
                return (props.value||[]).map(v => {
                    if (Number(v)) {
                        return props.items.find(item => item[props.itemValue] == v); 
                    }
                    return v;
                });
            },
            set: function(v) {
                var mappedValues = v;
                if (Array.isArray(v)) {
                    mappedValues = v.map(i => {
                        if (typeof i === 'object') {
                            return i[props.itemValue];
                        }
                        return i;
                    });
                }
//                console.log('ActionComboMulti set', v, mappedValues);                
                emit('input', mappedValues)
            }	
        })
    
        function itemRep(item) {
//            console.log('itemRep', item, props.itemText, props.itemShortText);
            if (!item) {
                return '';
            }
            if (Number(item)) {
                item = props.items.find(i => i[props.itemValue] == item); 
            }
//            console.log('itemRep', item, props.itemText, props.itemShortText);
            return ((dvalue?.value||[]).length<=2) ? item[props.itemText] : (item[props.itemShortText] || item[props.itemText])
        }
        const compSkeleton = computed({
            get() {
                if (props.skeleton) {
                    return true;
                }
                if (!props.model) {
                    return false;
                }
                return props.model.isDataLoading;
            }
        });
        const compDisabled = computed({
            get() {
                if (props.disabled) {
                    return true;
                }
                if (!props.model) {
                    return false;
                }
                return props.model.disabled;
            }
        });
    
    </script>
    